/* ============================================
   KOMPONEN: InfoRow
   ============================================ */
   export const InfoRowLogistic = ({ label, value, mono = false, danger = false }) => (
    <div className="flex items-center justify-between py-3" style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.15)" }}>
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</span>
      <span className={`text-sm font-medium ${mono ? "font-mono" : ""} ${danger ? "text-red-300" : "text-gray-100"}`}>{value || "—"}</span>
    </div>
  );
  